import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Menu } from './components/Menu';
import { Desserts } from './components/Desserts';
import { Merch } from './components/Merch';
import { Community } from './components/Community';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-hope-cream" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Menu data-id="element-5" />
        <Desserts data-id="element-6" />
        <Merch data-id="element-7" />
        <Community data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}